export function action(type, params) {
    if (typeof (type) !== 'string')
        throw "'type' parameter should be string.";
    if (params && params['type'])
        throw "You can't use 'type' keyword as property name.";
    return {
        type,
        ...params
    };
}
